import { Component } from '@angular/core';

@Component({
    selector: 'portal-accordion-wrapper',
    templateUrl: './accordion-wrapper.component.html',
    standalone: false
})
export class AccordionWrapperComponent {
  constructor() {}
}
